import { useNavigate } from "react-router-dom";
import board from "../assets/images/heroJ-board.png";
import queen from "../assets/images/hero-queen.png";
import rook from "../assets/images/hero-rook.png";

const Hero = () => {
  const navigate = useNavigate();

  const handleStartJourney = () => {
    navigate("/courses");
  };

  return (
    <section className="hero">
      <div className="hero-content">

        {/* LEFT : TEXT */}
        <div className="hero-text">
          <h1>
            Master the <span>Game of Kings</span>
          </h1>

          <p>
            Learn chess the right way with structured courses,
            real tournaments, and a growing community.
          </p>

          <button className="hero-cta" onClick={handleStartJourney}>
            Start Your Journey →
          </button>
        </div>

        {/* RIGHT : VISUAL */}
        <div className="hero-visual">
          <div className="board-group">
            <img src={queen} alt="Queen" className="hero-piece queen" />
            <img src={board} alt="Chess Board" className="hero-board" />
            <img src={rook} alt="Rook" className="hero-piece rook" />
          </div>
        </div>

      </div>
    </section>
  );
};

export default Hero;